import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "v-text"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_visibility = _resolveDirective("visibility")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("img", {
      class: "photo-list-img clickable",
      src: _ctx.imageSrc,
      loading: "lazy",
      "v-text": _ctx.textAlternative
    }, null, 8, _hoisted_1), [
      [_directive_visibility, _ctx.onVisibilityChanged]
    ])
  ]))
}